// Polyfill for dependencies that reference process (browser has no process)
const g = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
if (typeof g.process === 'undefined') {
  g.process = { env: typeof process !== 'undefined' && process.env ? process.env : {} };
}

import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import { unregister } from './registerServiceWorker';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
unregister();
